import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getUserMappingAndUsers,
  deleteUserMapping,
  updateGlobalJiraNotif,
  getAllWorkspacesFromGrid,
  deleteUserMappingsInGridWorkspaces,
} from '../skills_action';
import {
  Modal,
  Button,
  Table,
  Card,
  Alert,
  Typography,
  Tag,
  Menu,
  Divider,
  Dropdown,
  message,
  Popconfirm,
  Input,
  Space,
  notification,
  Select,
  Layout,
  Row,
  Col,
} from 'antd';
import UserMappingModal from './UserMappingModal';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import UserPopConfirm from './UserMappingPopConfirm';
import UserMappingReminder from './UserMappingReminder';
import UserMappingChannelReminder from './UserMappingChannelReminder';
const { Text } = Typography;
const { confirm } = Modal;
const { Option } = Select;
const { Content } = Layout;
class UserMapping extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      edit: false,
      mappeddata: {},
      showDeleteModal: false,
      userSearchTerm: '',
      userSearchArray: [],
      notifLoader: false,
      isAdmin: false,
      isAdminInfoLoaded: false,
      filterOption: 'all',
      currentPage: 1,
      defaultPageSize: 10,
      isGridWorkspace: false,
      gridInfo: [],
    };
    this.debounceTimer = null;
  }
  componentDidMount() {
    this.props.getUserMappingAndUsers(
      this.props.workspace_id,
      this.props.skill._id,
      false,
      '',
      this.state.currentPage,
      this.state.defaultPageSize
    );

    if (
      this.props.team &&
      this.props.team.bot &&
      this.props.team.bot.meta &&
      this.props.team.bot.meta.enterprise &&
      this.props.team.bot.meta.enterprise.id
    ) {
      this.setState({
        isGridWorkspace: true,
      });
      const domainUrl =
        this.props.currentSkill &&
        this.props.currentSkill.metadata &&
        this.props.currentSkill.metadata.domain_url;
      getAllWorkspacesFromGrid(
        this.props.match.params.wId,
        this.props.team.bot.meta.enterprise.id,
        domainUrl
      ).then((res) => {
        res.success &&
          this.setState({
            gridInfo: res.gridInfo,
          });
      });
    }

    /*axios.get(`/api/${this.props.match.params.wId}/isAdmin`).then(res => {
      if (res.data.isAdmin == false) {
        this.setState({ isAdminInfoLoaded: true });
      }
      if (res.data.success && res.data.isAdmin) {
        this.setState({
          isAdmin: true
        })
      }
    }).catch(err => {
      console.error("error in requesting server if current user is the admin of the workspace: ", err);
    })*/
  }
  showModal = () => {
    this.setState({ showModal: true });
  };
  handleCancel = () => {
    this.setState({ showModal: false, edit: false, mappeddata: {} });
  };
  onCreate = () => {
    this.setState({ showModal: false });
  };

  notificationClick = (key) => {
    notification.close(key);
    this.props.history.push(
      `/${this.props.match.params.wId}/skills/${this.props.match.params.skill_id}/${this.props.match.params.sub_skill}?view=personal_preferences`
    );
  };
  onUserMappingEdit = (record) => {
    if (record.isVerified) {
      const key = `open${Date.now()}`;
      const btn = (
        <Button onClick={() => this.notificationClick(key)}>
          Go to Jira Personal Preferences
        </Button>
      );
      // message.error("Verified accounts are the ones user has verified by logging into his Atlassian account. Verified accounts can be managed in Personal Preferences.")
      notification['error']({
        message:
          'This is a verified account. User has verified this mapping by logging into his Atlassian account. Verified accounts can be managed by the user in their Personal Preferences.',
        btn,
        key,
      });
    } else {
      this.setState({ showModal: true, edit: true, mappeddata: record });
    }
  };
  // deleteUserMapping(record){
  //   if(record.isVerified){
  // message.error('Verified accounts are the ones user has verified by logging into his Atlassian account. Verified accounts can be managed in Personal Preferences.')
  //   }
  //   else{
  //   }
  // }

  DeleteConfirmModal = (record) => {
    let that = this;
    confirm({
      title: 'Are you sure you want to remove this user mapping?',
      icon: <ExclamationCircleOutlined />,
      content: (
        <Row>
          <Col span={24}>
            Users without mapping will no longer see issues assigned to them in
            Slack. They will also not receive important notifications like
            @mentions from Jira.
          </Col>
          {this.state.isGridWorkspace && (
            <Col span={24} style={{ paddingTop: '8px' }}>
              <Text type='warning'>
                Note: deleting this user will remove them from all the mapped
                workspaces in the Grid that shares the same base URL.
              </Text>
            </Col>
          )}
        </Row>
      ),
      okText: 'Yes',
      okType: 'primary',
      cancelText: 'No',
      onOk() {
        that.state.isGridWorkspace
          ? that.props.deleteUserMappingsInGridWorkspaces(
              that.props.match.params.wId,
              record.user_id && record.user_id.user_id,
              { gridInfo: that.state.gridInfo.filter((item) => item !== null) }
            )
          : that.props.deleteUserMapping(
              that.props.match.params.wId,
              record._id
            );
      },
      onCancel() {},
    });
  };

  showDeleteConfirm = (record) => {
    let currentUserId = localStorage.getItem('trooprUserId');

    //if user is verified then the user should not be able to remove their own user mapping
    if (record.isVerified && record.user_id.user_id === currentUserId) {
      message.error('You cannot remove yourself from user mapping');
      return;
    }

    let isAdmin = this.props.isAdmin;

    //if the record is verified, it can only be removed by another user who is verified
    //or by any admin of this workspace
    if (record.isVerified) {
      //if (this.state.isAdmin) {
      if (isAdmin) {
        this.DeleteConfirmModal(record);
      } else {
        message.error(
          'Verified accounts are the ones user has verified by logging into his Atlassian account. Verified accounts can be managed in Personal Preferences.'
        );
      }
    } else {
      this.DeleteConfirmModal(record);
    }
  };
  showDeleteModal = () => {
    this.setState({ showDeleteModal: true });
  };
  handlePopConfirm = (value) => {
    this.setState({ popvisible: value });
  };

  getColumns = () => {
    const table_columns = [
      // {
      //   title: 'Slack Name',
      //   dataIndex: ['user_id', 'user_name'],
      //   key: "user_id._id",

      //   align: 'center',
      //   render: (text, record) => {
      //     return <span>{text}</span>
      //   },
      // },
      {
        title: 'Slack account',
        dataIndex: 'user_id',
        key: 'user_id._id',
        align: 'center',
        render: (text, record) => {
          // return <span>{text && text.name ? text.name : text.user_name}<br/>{text && text.email}</span>
          return (
            <span>
              {text && (text.displayName || text.name || text.user_name || '')}
              <br />
              {text && text.email}
            </span>
          );
        },
      },
      {
        title: 'Jira account',
        dataIndex: 'user_obj',
        key: '_id',

        align: 'center',
        render: (text, record) => {
          //console.info("text JIra",text)
          /*let display=""
          if(text && text.displayName && text.displayName && text.emailAddress){
            display=text.displayName+" ("+text.emailAddress+")"
          }*/
          return (
            <Fragment>
              {text && text.displayName && text.displayName}
              <br />
              {text &&
                text.displayName != text.emailAddress &&
                text.emailAddress}
            </Fragment>
          );
        },
      },
      /*{
        title: 'Email Id',
        dataIndex: 'user_id',
        key: "user_id._id",

        align: 'center',
        render: (text, record) => {
          return <Fragment>{text && text.email && text.email}</Fragment>
        },
      },*/
      {
        title: 'Verified',
        key: 'is_verified',
        dataIndex: 'is_enabled',

        render: (text, record) => {
          if (record.isVerified) {
            return <Tag color='green'>Yes</Tag>;
          } else {
            return (
              <>
                <Tag color='orange'>NO</Tag>
                <UserMappingReminder
                  closeModal={this.closeReminderModal}
                  record={record}
                  key={record._id}
                  user={this.props.user}
                />
              </>
            );
          }
        },
      },
      {
        title: 'Actions',
        key: 'actions',
        align: 'center',
        width: 150,
        render: (text, record) => {
          return (
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item key='1'>
                    <div
                      onClick={() => this.onUserMappingEdit(record)}
                      style={{ width: '100%' }}
                    >
                      Edit
                    </div>
                  </Menu.Item>
                  <Menu.Item
                    key='2'
                    onClick={() => this.showDeleteConfirm(record)}
                  >
                    <div style={{ width: '100%' }}>Delete</div>
                  </Menu.Item>
                </Menu>
              }
            >
              <a href='#'>More</a>
            </Dropdown>
          );
        },
      },
    ];
    return table_columns;
  };
  userSearch = (event) => {
    const searchTerm = event.target.value;
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      // wId, skillId, getCount,searchTerm,page,pageSize,filterOption
      this.props.getUserMappingAndUsers(
        this.props.workspace_id,
        this.props.skill._id,
        false,
        searchTerm,
        null,
        null,
        this.state.filterOption
      );
    }, 500);
    this.setState({ userSearchTerm: searchTerm, currentPage: 1 });

    // let searchData = [...this.props.usermappings.userMappingsWithUsers];
    // // let data = searchData.filter(user => (user.user_id.name.toLowerCase().includes(this.state.userSearchTerm.trim().toLowerCase()) || (user.user_obj.displayName.toLowerCase().includes(this.state.userSearchTerm.trim().toLowerCase()))))
    // // let data = searchData.filter(user => (((user.user_id.name ? user.user_id.name : user.user_id.user_name ? user.user_id.user_name : '').toLowerCase().includes(this.state.userSearchTerm.trim().toLowerCase())) || (user.user_obj && user.user_obj.displayName ? user.user_obj.displayName.toLowerCase().includes(this.state.userSearchTerm.trim().toLowerCase()) : '')));
    // let data = searchData.filter(
    //   (user) =>
    //     (
    //       user.user_id.displayName ||
    //       user.user_id.name ||
    //       user.user_id.user_name ||
    //       ''
    //     )
    //       .toLowerCase()
    //       .includes(this.state.userSearchTerm.trim().toLowerCase()) ||
    //     (user.user_obj && user.user_obj.displayName
    //       ? user.user_obj.displayName
    //           .toLowerCase()
    //           .includes(this.state.userSearchTerm.trim().toLowerCase())
    //       : '')
    // );
    // this.setState({ userSearchArray: data });
    // });
  };

  sorter = (a, b) => {
    let fa = a.user_id.user_name.toLowerCase(),
      fb = b.user_id.user_name.toLowerCase();
    if (fa < fb) return -1;
    if (fb < fa) return 1;

    return 0;
  };

  onFilterChange = (value) => {
    this.setState({ filterOption: value, currentPage: 1 });
    this.props.getUserMappingAndUsers(
      this.props.workspace_id,
      this.props.skill._id,
      false,
      this.state.userSearchTerm,
      null,
      null,
      value
    );
  };

  getFilterdData = (data) => {
    const { filterOption } = this.state;
    if (filterOption === 'all')
      return data; // default option when component rendered
    else if (filterOption === 'verified')
      return data.filter((d) => d.isVerified);
    else if (filterOption === 'not_verified')
      return data.filter((d) => !d.isVerified);
    else return data;
  };

  getContent = ({
    totalVerifiedAccounts,
    totalMappedUsers,
    paginationTotal,
  }) => {
    return (
      <>
        <Alert
          style={{ marginBottom: 16 }}
          description={
            <div>
              Linking enables user @mentions, personal notifications and nudges
              to be delivered as direct messages in Slack.
              <br /> When user authenticate his Atlassian account, user account
              mapping is automatically created. For others mapping can be done
              on their behalf.
            </div>
          }
          type='info'
        />
        <Card
          extra={
            <Space size='large'>
              <Input
                placeholder='Search User'
                onChange={this.userSearch}
                value={this.state.userSearchTerm}
              />
              <Select
                style={{ width: '150px' }}
                onChange={this.onFilterChange}
                value={this.state.filterOption}
              >
                <Option key={'all'} value={'all'}>
                  All
                </Option>
                <Option key={'verified'} value={'verified'}>
                  Verifed
                </Option>
                <Option key={'not_verified'} value={'not_verified'}>
                  Not Verified
                </Option>
              </Select>
              <Button type='primary' onClick={this.showModal}>
                New Mapping
              </Button>

              <UserMappingChannelReminder user={this.props.user} />
            </Space>
          }
        >
          {/* <Table  rowKey="_id" columns={this.getColumns()} dataSource={this.props.usermappings} pagination={{ pageSize: 20 }} /> */}
          <Table
            rowKey='_id'
            columns={this.getColumns()}
            // dataSource={((this.state.userSearchArray.length > 0 && this.state.userSearchTerm.trim().length > 0) || this.state.userSearchTerm.trim().length > 0) ? this.state.userSearchArray.sort((a,b) => this.sorter(a,b)) : this.props.usermappings.sort((a,b) => this.sorter(a,b))}
            dataSource={this.getFilterdData(
              this.props.usermappings &&
                this.props.usermappings.userMappingsWithUsers.sort((a, b) =>
                  this.sorter(a, b)
                )
            )}
            pagination={{
              defaultPageSize: this.state.defaultPageSize,
              current: this.state.currentPage,
              showSizeChanger: true,
              total: paginationTotal || 0,
              onChange: this.handlePaginationChange,
            }}
            title={() =>
              this.state.filterOption == 'not_verified'
                ? `${
                    totalMappedUsers - totalVerifiedAccounts
                  } unverified account(s)`
                : this.state.filterOption == 'verified'
                ? `${totalVerifiedAccounts} verified account(s)`
                : `${totalVerifiedAccounts} of ${totalMappedUsers} verified account(s)`
            }
          />
        </Card>
        {this.state.showModal && (
          <UserMappingModal
            isEdit={this.state.edit}
            visible={this.state.showModal}
            onCancel={this.handleCancel}
            onCreate={this.onCreate}
            mappeddata={this.state.mappeddata}
            gridInfoData={this.state.gridInfo}
            isGridWorkspace={this.state.isGridWorkspace}
          />
        )}
        <div style={{ marginTop: '16px', marginBottom: '16px' }}>
          <Alert
            message='Verified accounts are the ones user has verified by logging into his Atlassian account. Verified accounts can be managed in Personal Preferences.'
            type='warning'
            showIcon
          />
        </div>
      </>
    );
  };

  handlePaginationChange = (page, pageSize) => {
    this.setState({ currentPage: page, defaultPageSize: pageSize });
    this.props.getUserMappingAndUsers(
      this.props.workspace_id,
      this.props.skill._id,
      false,
      this.state.userSearchTerm,
      page,
      pageSize,
      this.state.filterOption
    );
  };

  render() {
    const { totalVerifiedAccounts, totalMappedUsers, paginationTotal } = this
      .props.usermappings || {
      totalMappedUsers: 0,
      totalVerifiedAccounts: 0,
      paginationTotal: 0,
    };

    // console.log("this.props.isJiraConnector _> ", this.props.isJiraConnector);

    // const { members, user } = this.props;
    let isAdminInfoLoaded = false;
    let isAdmin = this.props.isAdmin;
    isAdminInfoLoaded = true;
    // if (members && members.length > 0) {
    //   let user_now = members.find(
    //     (member) => member.user_id && member.user_id._id === user._id && user
    //   );
    //   if (user_now && user_now.role) {
    //     if (user_now.role == 'admin') {
    //       isAdmin = true;
    //     } else {
    //       isAdminInfoLoaded = true;
    //     }
    //   } else {
    //   }
    // }

    if (this.props.isFromCheckins) {
    } else {
      if (isAdminInfoLoaded) {
        if (!(isAdmin || this.props.isJiraConnector)) {
          this.props.history.push(`/${this.props.match.params.wId}/dashboard`);
        }
      }
    }

    /*if(this.state.isAdminInfoLoaded){
        if(!(this.state.isAdmin || this.props.isJiraConnector)){
          message.warning('You must be a workspace admin to see Usermapping')
          this.props.history.push(`/${this.props.match.params.wId}/dashboard`)
        }
      }
      */

    return this.props.isFromCheckins ? (
      isAdmin || this.props.isJiraConnector ? (
        this.getContent({
          totalVerifiedAccounts,
          totalMappedUsers,
          paginationTotal,
        })
      ) : (
        ''
      )
    ) : (
      <Layout
        style={{
          marginLeft: 0,
        }}
      >
        <Content
          /* className={'content_row_jira'} */ style={{
            overflow: 'auto',
            height: '95vh',
          }}
          className='main-content-padding'
        >
          {this.getContent({
            totalVerifiedAccounts,
            totalMappedUsers,
            paginationTotal,
          })}
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    skill: state.skills.currentSkill,
    usermappings: state.skills.usermappings,
    user: state.common_reducer.user,

    global_row_gutter: state.common_reducer.global_row_gutter,
    isAdmin: state.common_reducer.isAdmin,
    currentSkill: state.skills.currentSkill,
    team: state.skills.team,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    getUserMappingAndUsers,
    deleteUserMapping,
    updateGlobalJiraNotif,
    getAllWorkspacesFromGrid,
    deleteUserMappingsInGridWorkspaces,
  })(UserMapping)
);
